import { AvailableDatesGridView } from '~/components/system/available-dates';
import { PageContainer } from '~/components/page-container';

export function AvailableDates() {
	return (
		<PageContainer>
			<AvailableDatesGridView />
		</PageContainer>
	);
}
